<template>
<div class="menuYingyou" id="footer">
  <div class="item" v-for="(item,index) of menuData" :key="index" @click="goProductList(item)" :class="{active: $route.path.indexOf(item['url'+item.type])!=-1 }">
    <img :src="$route.path.indexOf(item.url)!=-1 ? item['imgA'+item.type] : item.img" class="icon" alt="" />
    <p class="name">{{ item['text'+item.type] }}</p>
  </div>
  <!-- <div class="line"></div> -->
</div>
</template>

<script>
export default {
  props:['top'],
  data() {
    return {
      menuData:[
        {
          type:'',
          text:'首页',
          img:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/home%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png',
          imgA:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/home%402x.png',
          url:'index',
          url2:'index',
          text2:'回到顶部',
          imgA2:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%9B%9E%E5%88%B0%E9%A1%B6%E9%83%A8%402x.png'
        },{
          text:'职业能力认证',
          img:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E8%81%8C%E4%B8%9A%E8%83%BD%E5%8A%9B%E8%AE%A4%E8%AF%81%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png',
          imgA:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E8%81%8C%E4%B8%9A%E8%83%BD%E5%8A%9B%E8%AE%A4%E8%AF%81%402x.png',
          url:'lessonYingyou',
          id: 172,
          type:'',
        },{
          text:'我的',
          img:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E6%88%91%E7%9A%84%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png',
          imgA:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E6%88%91%E7%9A%84%402x.png',
          url:'userYingyou/center',
          type:'',
        },
      ]
    };
  },
  watch:{
    top(){
      if(this.$route.path.indexOf('index')!=-1){
        this.menuData[0].type = this.top<0 ? 2: ''
      }
    }
  },
  mounted() {
  },
  methods: {
    
    goProductList(item) {
      if(this.top<0 && item.url == 'index'){
        this.$emit('toTop')
        return
      }
      if(item.url.indexOf('center')!=-1 && !localStorage.getItem('userdata')){
        this.$dialog.confirm({
          title: '',
          message:
            '您还未登录，请登录',
        })
          .then(() => {
            console.log('111')
            this.$router.push('/'+this.$route.params.plat_type+'/login/phone')
            
          })
          .catch(() => {
            // on cancel
          });
        return
      }
      this.$store.dispatch("jump", {
        path: item.id? '/'+this.$route.params.plat_type+'/'+item.url+"?id="+item.id:'/'+this.$route.params.plat_type+'/'+item.url,
      });
    },
  },
};
</script>

<style scoped>
.menuYingyou {
  width: 100vw;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: fixed;
  z-index: 100;
  bottom: 0;
  left: 0;
  justify-content: space-evenly;
  background: #fff;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.icon {
  width: 42px;
  display: inline-block;
  margin-bottom: 10px;
}

.menuYingyou .name {
  font-size: 20px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}

.line {
  width: 690px;
  height: 2px;
  background: #eee;
  margin: 34px auto 10px;
}
.active .name{
  color: #000;
}
</style>>
